import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'meu-app-home-page-search',
  templateUrl: './app-home-page-search.component.html',
  styleUrls: ['./app-home-page-search.component.scss']
})
export class AppHomePageSearchComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }
  search:any = '';
  ngOnInit() {
  }
  nextPageSearch(){
    this.router.navigate([
      '/searchresultpage',
    ], { queryParams: { search: this.search.trim() } });

  }
}
